import { inject, Pipe, PipeTransform } from '@angular/core';
import { LangueService } from '../services/langue/langue.service';
import { LangueEnum } from '../constantes/langue.enum';

@Pipe({
  name: 'dateCustom',
  standalone: false,
})
export class DateCustomPipe implements PipeTransform {
  isFrancais: boolean = true;

  private readonly langueService = inject(LangueService);

  transform(date: string): string {
    if (!date) return '';
    this.isFrancais = this.langueService.getCurrentLanguage() === LangueEnum.FR;

    let parsedDate: Date;
    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      const [year, month, day] = date.split('-').map(Number);
      parsedDate = new Date(year, month - 1, day);
    } else {
      parsedDate = new Date(date);
    }

    const jour = parsedDate.getDate();
    const moisFr = parsedDate.toLocaleString('fr-FR', { month: 'long' });
    const moisEn = parsedDate.toLocaleString('en-US', { month: 'long' });
    const annee = parsedDate.getFullYear();

    if (this.isFrancais) {
      if (jour === 1) {
        return `1<sup>er</sup> ${moisFr} ${annee}`;
      }
      return `${jour} ${moisFr} ${annee}`;
    } else {
      return `${moisEn} ${jour}, ${annee}`;
    }
  }
}
